/* =========================================================
   Stick Shift Goods — theme.js
   Uses Shopify's built-in Ajax Cart API (/cart/add.js, /cart/change.js,
   /cart.js) rather than custom endpoints. No frameworks required.
   ========================================================= */
(function () {
  'use strict';

  var moneyFormat = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-mobile-nav-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileNav) { mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-mobile-nav-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileNav) { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('CartDrawer');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', openCartDrawer);
  });
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function updateFreeShippingBar(cartTotal) {
    var bar = document.getElementById('FreeShippingBar');
    if (!bar || !cartDrawer) return;
    var threshold = parseInt(cartDrawer.getAttribute('data-free-shipping-threshold'), 10);
    if (!threshold || threshold <= 0) { bar.hidden = true; return; }

    bar.hidden = false;
    var message = document.getElementById('FreeShippingBarMessage');
    var fill = document.getElementById('FreeShippingBarFill');
    var percent = Math.min(100, Math.round((cartTotal / threshold) * 100));
    if (fill) fill.style.width = percent + '%';

    if (cartTotal >= threshold) {
      if (message) message.innerHTML = '<strong>&#10003; You’ve unlocked free shipping!</strong>';
    } else {
      var remaining = formatMoney(threshold - cartTotal);
      if (message) message.innerHTML = 'Add <strong>' + remaining + '</strong> more for free shipping';
    }
  }

  function renderCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = document.getElementById('CartDrawerBody');
        var subtotal = document.getElementById('CartDrawerSubtotal');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
        updateCartCount(cart.item_count);
        updateFreeShippingBar(cart.total_price);
        if (!body) return;

        if (cart.item_count === 0) {
          body.innerHTML = '<p style="padding:24px 0;color:var(--color-text-faint);">Your cart is empty.</p>';
          return;
        }

        var html = '';
        cart.items.forEach(function (item) {
          html += '<div class="cart-line">' +
            '<img src="' + item.image + '&width=180" alt="' + item.title.replace(/"/g, '&quot;') + '">' +
            '<div><div class="cart-line__title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '') +
            '<div style="margin-top:8px;font-size:0.82rem;color:var(--color-text-faint);">Qty ' + item.quantity + '</div></div>' +
            '<div style="text-align:right;">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>';
        });
        body.innerHTML = html;
      })
      .catch(function () {});
  }

  /* ---------- Add to cart (Ajax) ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = document.getElementById('AddToCartBtn');
      var formData = new FormData(productForm);
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Added ✓'; setTimeout(function () { submitBtn.textContent = submitBtn.dataset.originalText; }, 1500); }
          openCartDrawer();
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        });
    });
  }

  var buyNowBtn = document.querySelector('[data-buy-now]');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function (e) {
      if (buyNowBtn.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      e.preventDefault();
      var formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function () { window.location.href = '/cart/checkout'; });
    });
  }

  /* ---------- Quantity steppers (product page) ---------- */
  var qtyInput = document.getElementById('ProductQuantity');
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus = document.querySelector('[data-qty-plus]');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1); });
    qtyPlus.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1; });
  }

  /* ---------- Cart page quantity changes (Ajax /cart/change.js) ---------- */
  document.querySelectorAll('[data-cart-qty-minus], [data-cart-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-line');
      var input = document.querySelector('[data-cart-qty-input][data-line="' + line + '"]');
      if (!input) return;
      var delta = btn.hasAttribute('data-cart-qty-minus') ? -1 : 1;
      var newQty = Math.max(0, parseInt(input.value, 10) + delta);
      input.value = newQty;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- Variant selection (uses embedded variants JSON, no custom API) ---------- */
  var variantsJsonEl = document.getElementById('ProductVariantsJson');
  if (variantsJsonEl) {
    var variants = JSON.parse(variantsJsonEl.textContent);
    var optionGroups = document.querySelectorAll('.option-selector__values[data-option-index]');
    var variantIdInput = document.getElementById('ProductVariantId');
    var addToCartBtn = document.getElementById('AddToCartBtn');
    var lowStockThreshold = productForm ? parseInt(productForm.getAttribute('data-low-stock-threshold'), 10) || 0 : 0;
    var showLowStock = !!(productForm && productForm.getAttribute('data-show-low-stock') === 'true');

    function getSelectedOptions() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.option-value.is-selected');
        selected.push(active ? active.getAttribute('data-option-value') : null);
      });
      return selected;
    }

    function findMatchingVariant(selected) {
      return variants.find(function (v) {
        return selected.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (addToCartBtn) { addToCartBtn.disabled = true; addToCartBtn.textContent = 'Unavailable'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      var priceEl = document.querySelector('.product-info__price .price');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      var stockNote = document.getElementById('StockNote');
      if (stockNote) {
        stockNote.className = variant.available ? 'stock-note stock-note--in' : 'stock-note stock-note--out';
        stockNote.innerHTML = variant.available
          ? '<span class="stock-dot"></span> In stock, ready to ship'
          : '<span class="stock-dot"></span> Out of stock';
      }
      var lowStockNote = document.getElementById('LowStockNote');
      var isLow = showLowStock && variant.available && variant.inventory_management === 'shopify' &&
        variant.inventory_quantity > 0 && variant.inventory_quantity <= lowStockThreshold;
      if (isLow) {
        var message = 'Only ' + variant.inventory_quantity + ' left in stock — order soon';
        if (lowStockNote) {
          lowStockNote.textContent = message;
        } else if (stockNote) {
          lowStockNote = document.createElement('div');
          lowStockNote.id = 'LowStockNote';
          lowStockNote.className = 'stock-note stock-note--low';
          lowStockNote.textContent = message;
          stockNote.insertAdjacentElement('afterend', lowStockNote);
        }
      } else if (lowStockNote) {
        lowStockNote.remove();
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.option-value').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.option-value').forEach(function (b) {
            b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-selected'); btn.setAttribute('aria-checked', 'true');
          var variant = findMatchingVariant(getSelectedOptions());
          updateForVariant(variant);
        });
      });
    });
  }

  /* ---------- Mega menu ---------- */
  document.querySelectorAll('[data-mega-item]').forEach(function (item) {
    var trigger = item.querySelector('.mega-nav__trigger');
    if (!trigger) return;
    function open() { item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
    function close() { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    trigger.addEventListener('click', function () { item.classList.contains('is-open') ? close() : open(); });
    trigger.addEventListener('focus', open);
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close();
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.mega-nav__item.is-open').forEach(function (item) {
      if (!item.contains(e.target)) { item.classList.remove('is-open'); }
    });
  });

  /* ---------- Product zoom lightbox ---------- */
  var zoomLightbox = document.getElementById('ZoomLightbox');
  var zoomImage = document.getElementById('ZoomLightboxImage');
  document.querySelectorAll('[data-zoom-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mainImg = document.getElementById('ProductMainImage');
      if (!mainImg || !zoomLightbox || !zoomImage) return;
      zoomImage.src = mainImg.getAttribute('data-zoom-src') || mainImg.src;
      zoomImage.alt = mainImg.alt;
      zoomLightbox.classList.add('is-open');
      zoomLightbox.setAttribute('aria-hidden', 'false');
    });
  });
  function closeZoom() {
    if (!zoomLightbox) return;
    zoomLightbox.classList.remove('is-open');
    zoomLightbox.setAttribute('aria-hidden', 'true');
  }
  document.querySelectorAll('[data-zoom-close]').forEach(function (btn) { btn.addEventListener('click', closeZoom); });
  if (zoomImage) zoomImage.addEventListener('click', closeZoom);

  /* ---------- Gallery: images + video/model media (single handler, no duplicates) ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mediaType = thumb.getAttribute('data-media-type');
      var mainMediaContainer = document.getElementById('ProductMainMedia');
      var mainImg = document.getElementById('ProductMainImage');

      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('is-active'); thumb.setAttribute('aria-selected', 'true');

      if (mediaType === 'video' || mediaType === 'external_video') {
        var store = document.querySelector('#ProductMediaStore [data-media-id="' + thumb.getAttribute('data-media-id') + '"]');
        var zoomContainer = document.querySelector('[data-zoom-container]');
        if (store && zoomContainer) {
          zoomContainer.querySelectorAll('img, .product-gallery__zoom-btn, #ProductMainMedia').forEach(function (el) { el.remove(); });
          var wrapper = document.createElement('div');
          wrapper.id = 'ProductMainMedia';
          wrapper.innerHTML = store.innerHTML;
          zoomContainer.prepend(wrapper);
        }
      } else if (mainImg) {
        mainImg.src = thumb.getAttribute('data-full');
        mainImg.setAttribute('data-zoom-src', thumb.getAttribute('data-full'));
        if (mainMediaContainer) mainMediaContainer.remove();
      }
    });
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var answer = btn.nextElementSibling;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      if (answer) answer.hidden = isOpen;
    });
  });

  /* ---------- Product recommendations (native Shopify API) ---------- */
  var recsEl = document.querySelector('[data-product-recommendations]');
  if (recsEl) {
    fetch(recsEl.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.getElementById('ProductRecommendationsGrid');
        if (grid && grid.innerHTML.trim() !== '') {
          document.getElementById('ProductRecommendationsGrid').innerHTML = grid.innerHTML;
          recsEl.hidden = false;
        }
      })
      .catch(function () {});
  }

  /* ---------- Recently viewed (localStorage + built-in {handle}.js API) ---------- */
  var RECENTLY_VIEWED_KEY = 'stickshift_recently_viewed';
  if (document.body.getAttribute('data-product-handle')) {
    try {
      var handle = document.body.getAttribute('data-product-handle');
      var viewed = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];
      viewed = viewed.filter(function (h) { return h !== handle; });
      viewed.unshift(handle);
      viewed = viewed.slice(0, 8);
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(viewed));
    } catch (e) {}
  }
  var recentlyViewedEl = document.querySelector('[data-recently-viewed]');
  if (recentlyViewedEl) {
    try {
      var currentHandle = document.body.getAttribute('data-product-handle');
      var handles = (JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []).filter(function (h) { return h !== currentHandle; }).slice(0, 4);
      if (handles.length > 0) {
        Promise.all(handles.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
          .then(function (products) {
            products = products.filter(Boolean);
            if (products.length === 0) return;
            var grid = document.getElementById('RecentlyViewedGrid');
            grid.innerHTML = products.map(function (p) {
              var img = p.featured_image || (p.images && p.images[0]) || '';
              return '<a href="' + p.url + '" class="product-card"><div class="product-card__media"><img src="' + img + '&width=600" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy"></div>' +
                '<div class="product-card__body"><div class="product-card__title">' + p.title + '</div><div class="product-card__price"><span class="price">' + formatMoney(p.price) + '</span></div></div></a>';
            }).join('');
            recentlyViewedEl.hidden = false;
          });
      }
    } catch (e) {}
  }

  /* ---------- Selling plan (subscription) toggle ---------- */
  document.querySelectorAll('[data-selling-plan-radio]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      var sellingPlanInput = document.getElementById('SellingPlanId');
      if (sellingPlanInput) sellingPlanInput.value = radio.value;
    });
  });

  /* ---------- Kit builder ---------- */
  document.querySelectorAll('[data-kit-builder]').forEach(function (kit) {
    var checkboxes = kit.querySelectorAll('[data-kit-item]');
    var totalEl = kit.querySelector('#KitTotal');
    var addBtn = kit.querySelector('[data-kit-add-to-cart]');

    function updateTotal() {
      var total = 0;
      checkboxes.forEach(function (cb) { if (cb.checked) total += parseInt(cb.getAttribute('data-price'), 10) || 0; });
      if (totalEl) totalEl.textContent = formatMoney(total);
    }
    checkboxes.forEach(function (cb) { cb.addEventListener('change', updateTotal); });
    updateTotal();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        checkboxes.forEach(function (cb) {
          if (cb.checked) items.push({ id: parseInt(cb.getAttribute('data-variant-id'), 10), quantity: 1 });
        });
        if (items.length === 0) return;
        addBtn.disabled = true; addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function () {
          addBtn.disabled = false; addBtn.textContent = 'Add Kit to Cart';
          openCartDrawer();
        }).catch(function () {
          addBtn.disabled = false; addBtn.textContent = 'Add Kit to Cart';
        });
      });
    }
  });

  /* ---------- Find Your Mount quiz ---------- */
  document.querySelectorAll('[data-quiz]').forEach(function (quiz) {
    var steps = quiz.querySelectorAll('[data-quiz-step]');
    var dots = quiz.querySelectorAll('[data-quiz-dot]');
    var answers = {};

    function showStep(index) {
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    showStep(0);

    quiz.querySelectorAll('[data-quiz-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepIdx = btn.getAttribute('data-step');
        answers[stepIdx] = btn.getAttribute('data-value');
        var currentStepEl = btn.closest('[data-quiz-step]');
        var currentIndex = Array.prototype.indexOf.call(steps, currentStepEl);

        if (currentIndex < steps.length - 2) {
          showStep(currentIndex + 1);
        } else {
          var resultStep = quiz.querySelector('[data-quiz-result-step]');
          var results = quiz.querySelectorAll('[data-quiz-result]');
          var matched = null;
          results.forEach(function (r) {
            var match = (r.getAttribute('data-match') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
            if (match.length === 0) return;
            var allMatch = match.every(function (pair) {
              var kv = pair.split(':');
              return answers[kv[0]] === kv[1];
            });
            if (allMatch && !matched) matched = r;
          });
          results.forEach(function (r) { r.hidden = true; });
          var fallback = resultStep.querySelector('[data-quiz-result-default]');
          if (matched) { matched.hidden = false; } else if (fallback) { fallback.hidden = false; }
          showStep(steps.length - 1);
        }
      });
    });
    quiz.querySelectorAll('[data-quiz-restart]').forEach(function (btn) {
      btn.addEventListener('click', function () { answers = {}; showStep(0); });
    });
  });

  /* ---------- Wishlist (localStorage, no account required) ---------- */
  var WISHLIST_KEY = 'stickshift_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    updateWishlistCountBadges(list);
  }
  function isWished(handle, list) {
    return (list || getWishlist()).some(function (item) { return item.handle === handle; });
  }
  function updateWishlistCountBadges(list) {
    list = list || getWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }
  function refreshWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = isWished(btn.getAttribute('data-product-handle'), list);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var handle = btn.getAttribute('data-product-handle');
      var list = getWishlist();
      if (isWished(handle, list)) {
        list = list.filter(function (item) { return item.handle !== handle; });
      } else {
        list.push({
          handle: handle,
          title: btn.getAttribute('data-product-title'),
          url: btn.getAttribute('data-product-url'),
          image: btn.getAttribute('data-product-image'),
          price: parseInt(btn.getAttribute('data-product-price'), 10) || 0
        });
      }
      setWishlist(list);
      refreshWishlistButtons();
      renderWishlistPage();
    });
  });
  refreshWishlistButtons();
  updateWishlistCountBadges();

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    var summary = document.querySelector('[data-wishlist-summary]');
    if (!grid) return;
    var list = getWishlist();
    if (summary) summary.textContent = list.length + (list.length === 1 ? ' item' : ' items');
    if (list.length === 0) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(function (item) {
      return '<div class="product-card">' +
        '<button type="button" class="wishlist-btn product-card__wishlist is-active" data-wishlist-remove="' + item.handle + '" aria-label="Remove ' + item.title.replace(/"/g, '&quot;') + ' from wishlist">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>' +
        '</button>' +
        '<a href="' + item.url + '" class="product-card__link">' +
        '<div class="product-card__media"><img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy"></div>' +
        '<div class="product-card__body">' +
        '<div class="product-card__title">' + item.title + '</div>' +
        '<div class="product-card__price"><span class="price">' + formatMoney(item.price) + '</span></div>' +
        '</div></a></div>';
    }).join('');

    grid.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.getAttribute('data-wishlist-remove');
        setWishlist(getWishlist().filter(function (item) { return item.handle !== handle; }));
        refreshWishlistButtons();
        renderWishlistPage();
      });
    });
  }
  renderWishlistPage();

  /* ---------- Collection filters ---------- */
  var filtersPanel = document.querySelector('[data-filters-panel]');
  var filtersBackdrop = document.querySelector('[data-filters-backdrop]');

  function openFilters() {
    if (!filtersPanel) return;
    filtersPanel.classList.add('is-open');
    if (filtersBackdrop) filtersBackdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    if (!filtersPanel) return;
    filtersPanel.classList.remove('is-open');
    if (filtersBackdrop) filtersBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-filters-open]').forEach(function (btn) {
    btn.addEventListener('click', openFilters);
  });
  document.querySelectorAll('[data-filters-close]').forEach(function (btn) {
    btn.addEventListener('click', closeFilters);
  });
  if (filtersBackdrop) filtersBackdrop.addEventListener('click', closeFilters);

  var facetsForm = document.getElementById('FacetFiltersForm');
  if (facetsForm) {
    // Progressive enhancement: auto-submit on sort/checkbox change. The
    // "Apply Filters" button still works with JS disabled, since this is a
    // real GET form built on Shopify's native Storefront Filtering API.
    var sortSelect = document.getElementById('SortBy');
    if (sortSelect) sortSelect.addEventListener('change', function () { facetsForm.submit(); });
    facetsForm.querySelectorAll('[data-facet-input]').forEach(function (input) {
      input.addEventListener('change', function () { facetsForm.submit(); });
    });
  }

  /* ---------- Close drawers on Escape ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCartDrawer(); closeZoom(); closeFilters(); if (mobileNav) mobileNav.classList.remove('is-open'); }
  });
})();
